import {
    canShowSketchPropertySection,
    handleSketchEntityPropertyConfirm,
    registerPropertyManagerSection,
    resolveSketchEntityPropertyActions,
} from '@/core';
import { SketchLineCommand } from '@puppycad/cad-core';
import LinePropertyManagerPanel from '@/components/editor/property-manager/line/LinePropertyManagerPanel.vue';

registerPropertyManagerSection({
    id: SketchLineCommand.Line,
    title: (context) => {
        return '线条属性';
    },
    order: 8,
    component: LinePropertyManagerPanel,
    actions: {
        confirm: true,
    },
    resolveActions: resolveSketchEntityPropertyActions,
    onConfirm: handleSketchEntityPropertyConfirm,
    isApplicable: (context) => {
        return canShowSketchPropertySection(context, context.linePropertyVisible === true);
    },
});
